import {
    DELETE_PROPERTY_SUCCESS,
    FETCH_PROPERTIES,
    FETCH_PROPERTIES_FAILURE,
    FETCH_PROPERTIES_SUCCESS,
    FETCH_PROPERTY,
    FETCH_PROPERTY_FAILURE,
    FETCH_PROPERTY_LOCALISATION,
    FETCH_PROPERTY_LOCALISATION_FAILURE,
    FETCH_PROPERTY_LOCALISATION_SUCCESS,
    CREATE_PROPERTY_LOCALISATION_SUCCESS,
    FETCH_PROPERTY_SUCCESS,
    PROPERTIES_LIST_FILTER_UPDATE,
    PROPERTIES_LIST_FILTER_CATEGORY,
    PROPERTIES_LIST_PAGE,
    PROPERTIES_LIST_SORT,
    SORT_ASC,
    UPDATE_PROPERTY_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    localisation: {},
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 24,
    total: 0,
};

export default function propertygroups(state = initialState, action) {
    switch (action.type) {
        case FETCH_PROPERTIES:
        case FETCH_PROPERTY:
        case FETCH_PROPERTY_LOCALISATION:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PROPERTIES_FAILURE:
        case FETCH_PROPERTY_FAILURE:
        case FETCH_PROPERTY_LOCALISATION_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PROPERTIES_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: action.payload.total,
            });

        case FETCH_PROPERTY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
            });

        case FETCH_PROPERTY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: reducerHelper.formatLocalisations(action.response.results),
                }),
            });

        case CREATE_PROPERTY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: Object.assign({}, action.response, action.payload.formValues.base),
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.response.id]: action.payload.formValues.localisation,
                }),
            });

        case UPDATE_PROPERTY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: Object.assign({}, action.response, action.payload.formValues.base),
                }),
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.response.id]: action.payload.formValues.localisation,
                }),
            });

        case PROPERTIES_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        case PROPERTIES_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case PROPERTIES_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case PROPERTIES_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case DELETE_PROPERTY_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/propertiesReducer.js